import { MarketingEventsDepartmentsGridPluginSettings } from "./MarketingEventsDepartments/MarketingEventsDepartmentsGridPluginSettings";
import { MarketingEventsDistributorsGridPluginSettings } from "./MarketingEventsDistributors/MarketingEventsDistributorsGridPluginSettings";
import { MarketingEventsFactDepartmentsGridPluginSettings } from "./MarketingEventsFactDepartments/MarketingEventsFactDepartmentsGridPluginSettings";
import { MarketingEventsPlanDepartmentsGridPluginSettings } from "./MarketingEventsPlanDepartments/MarketingEventsPlanDepartmentsGridPluginSettings";
import { MarketingEventsProductsGridPluginSettings } from "./MarketingEventsProducts/MarketingEventsProductsPluginSettings";

export const MarketingEventsGridPluginSettings: IPluginSettings = {
    name: 'Маркетинговые мероприятия',
    mnemocode: 'marketing_events_plugin',
    permission: 'MarketingEvents',
    detailsPlugins: [
        MarketingEventsProductsGridPluginSettings,
        MarketingEventsPlanDepartmentsGridPluginSettings,
        MarketingEventsFactDepartmentsGridPluginSettings,
        MarketingEventsDistributorsGridPluginSettings,
        MarketingEventsDepartmentsGridPluginSettings
    ],
    columns: (() => {
        let index = 0;
        return [
            {
                order: index++,
                propertyName: 'idGlobal',
                propertyType: 'string',
                displayName: 'idGlobal',
                visibility: false,
                width: 300
            },
            {
                order: index++,
                propertyName: 'idMarketingEvent',
                propertyType: 'number',
                displayName: 'ID маркетингового мероприятия',
                visibility: true,
                width: 120
            },
            {
                order: index++,
                propertyName: 'id',
                propertyType: 'number',
                displayName: 'ID',
                visibility: false,
                width: 80
            },
            {
                order: index++,
                propertyName: 'code',
                propertyType: 'string',
                displayName: 'Код',
                visibility: true,
                width: 120
            },
            {
                order: index++,
                propertyName: 'name',
                propertyType: 'string',
                displayName: 'Наименование',
                visibility: true,
                width: 300
            },
            {
                order: index++,
                propertyName: 'idContract',
                propertyType: 'number',
                displayName: 'Идентификатор договора',
                visibility: true,
                width: 100
            },
            {
                order: index++,
                propertyName: 'state',
                propertyType: 'number',
                displayName: 'Код состояния ММ',
                visibility: false,
                width: 150
            },
            {
                order: index++,
                propertyName: 'stateText',
                propertyType: 'string',
                displayName: 'Состояние ММ',
                visibility: true,
                width: 150
            },
            {
                order: index++,
                propertyName: 'type',
                propertyType: 'number',
                displayName: 'Код типа ММ',
                visibility: false,
                width: 150
            },
            {
                order: index++,
                propertyName: 'typeText',
                propertyType: 'string',
                displayName: 'Тип ММ',
                visibility: true,
                width: 150
            },
            {
                order: index++,
                propertyName: 'dateFrom',
                propertyType: 'datetime',
                displayName: 'Дата начала ММ',
                visibility: true,
                width: 150
            },
            {
                order: index++,
                propertyName: 'dateTo',
                propertyType: 'datetime',
                displayName: 'Дата окончания ММ',
                visibility: true,
                width: 150
            },
            {
                order: index++,
                propertyName: 'amountPlan',
                propertyType: 'number',
                displayName: 'Сумма план',
                visibility: true,
                width: 120
            },
            {
                order: index++,
                propertyName: 'amountFact',
                propertyType: 'number',
                displayName: 'Сумма факт',
                visibility: true,
                width: 120
            },
            {
                order: index++,
                propertyName: 'bonusPlan',
                propertyType: 'number',
                displayName: 'Бонус план',
                visibility: true,
                width: 120
            },
            {
                order: index++,
                propertyName: 'bonusFact',
                propertyType: 'number',
                displayName: 'Бонус факт',
                visibility: true,
                width: 120
            },
            {
                order: index++,
                propertyName: 'quantityPlan',
                propertyType: 'number',
                displayName: 'Кол-во план',
                visibility: true,
                width: 130
            },
            {
                order: index++,
                propertyName: 'quantityFact',
                propertyType: 'number',
                displayName: 'Кол-во факт',
                visibility: true,
                width: 130
            },
            {
                order: index++,
                propertyName: 'description',
                propertyType: 'string',
                displayName: 'Комментарий',
                visibility: true,
                width: 200
            },
            {
                order: index++,
                propertyName: 'idClassifierType',
                propertyType: 'number',
                displayName: 'Идентификатор типа классификатора',
                visibility: false,
                width: 150
            },
            {
                order: index++,
                propertyName: 'bonusLimited',
                propertyType: 'number',
                displayName: 'Ограничение по бонусу',
                visibility: true,
                width: 150
            },
            {
                order: index++,
                propertyName: 'extendDepartments',
                propertyType: 'boolean',
                displayName: 'Расширять список подразделений',
                visibility: true,
                width: 200
            },
            {
                order: index++,
                propertyName: 'idGoodsCompletedType',
                propertyType: 'number',
                displayName: 'Идентификатор типа выполнения',
                visibility: false,
                width: 160
            },
            {
                order: index++,
                propertyName: 'fullBonusThresholdPercent',
                propertyType: 'number',
                displayName: '% для полного бонуса', //Порог для начисления полного бонуса (в процентах)
                visibility: true,
                width: 150
            },
            {
                order: index++,
                propertyName: 'haveMinBonusThreshold',
                propertyType: 'boolean',
                displayName: 'Есть порог для уменьшенного бонуса', //Признак наличия порога для начисления уменьшенного бонуса
                visibility: true,
                width: 200
            },
            {
                order: index++,
                propertyName: 'minBonusThresholdPercent',
                propertyType: 'number',
                displayName: '% для уменьшенного бонуса', //Порог для начисления уменьшенного бонуса (в процентах),
                visibility: true,
                width: 160
            },
            {
                order: index++,
                propertyName: 'haveMaxBonusThreshold',
                propertyType: 'boolean',
                displayName: 'Есть порог для увеличенного бонуса', //Признак наличия порога для начисления увеличенного бонуса
                visibility: true,
                width: 200
            },
            {
                order: index++,
                propertyName: 'maxBonusThresholdPercent',
                propertyType: 'number',
                displayName: '% для увеличенного бонуса', //Порог для начисления увеличенного бонуса (в процентах)
                visibility: true,
                width: 160
            },
            {
                order: index++,
                propertyName: 'deflatorPercent',
                propertyType: 'number',
                displayName: 'Дефлятор (%)',
                visibility: true,
                width: 120
            },
            {
                order: index++,
                propertyName: 'inflatorPercent',
                propertyType: 'number',
                displayName: 'Инфлятор (%)',
                visibility: true,
                width: 120
            },
            {
                order: index++,
                propertyName: 'idMemberType',
                propertyType: 'number',
                displayName: 'Идентификатор типа участника',
                visibility: false,
                width: 120
            },
            {
                order: index++,
                propertyName: 'percentageOfCompletion',
                propertyType: 'number',
                displayName: 'Процент выполнения',
                visibility: true,
                width: 140
            },
            {
                order: index++,
                propertyName: 'deleted',
                propertyType: 'boolean',
                displayName: 'Удален',
                visibility: false,
                width: 100
            },
            {
                order: index++,
                propertyName: 'isDeleted',
                propertyType: 'boolean',
                displayName: 'Удален',
                visibility: false,
                width: 150
            },
            {
                order: index++,
                propertyName: 'dateCreated',
                propertyType: 'datetime',
                displayName: 'Дата создания',
                visibility: false,
                width: 150
            },
            {
                order: index++,
                propertyName: 'dateModified',
                propertyType: 'datetime',
                displayName: 'Дата изменения',
                visibility: false,
                width: 150
            },
            {
                order: index++,
                propertyName: 'dateDeleted',
                propertyType: 'datetime',
                displayName: 'Дата удаления',
                visibility: false,
                width: 150
            },            
            {
                order: index++,
                propertyName: 'rowVer',
                propertyType: 'number',
                displayName: 'Версия строки',
                visibility: false,
                width: 120
            }            
        ]
        
    })()
};